import ShoppingCar from './product-list/product-list'

export default ShoppingCar
